import LabServiceCollection from "@/collections/LabServiceCollection";
import AttributeListKinModel from "@/models/lab/AttributeListKinModel";

export default class AttributeListKinCollection extends LabServiceCollection {
  model() {
    return AttributeListKinModel;
  }
}
